import React, { useEffect, useState } from "react";
import Select from "react-select";
import { internType } from "../../data/interntype-data";
import CardEl from "../../Elements/CardEl";
import DatePicker from "react-datepicker";
import { engApi } from "../../api/engApi";
import { convertDateToString, dateDiff } from "../../utils/function";

const TypeEl = ({ hooksForm, Controller, internType, setInternType }) => {
  const { register, watch, control, setValue } = hooksForm;

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [periodSelected, setPeriodSelected] = useState(1);
  const watchPeriod = watch("period");
  const watchInternType = watch("intern-type");
  const [optionsInternType, setOptionsInternType] = useState([]);

  const getInternType = () => {
    engApi
      .get("/internship-date/")
      .then((res) => {
        const list = res.data.filter((el) => el.type != "4");

        const list2 = list.map((item) => {
          let text = "";

          if (item.type == 1) {
            text = "ฝึกงานภาคฤดูร้อน (2เดือน)";
          } else if (item.type == 2) {
            text = "ฝึกงานภาคฤดูร้อน และสหกิจศึกษา (4เดือน)";
          } else if (item.type == 3) {
            text = "ฝึกงานภาคฤดูร้อน และสหกิจศึกษา (6เดือน)";
          }

          return {
            label: text,
            value: item.type,
            data: item,
          };
        });

        setOptionsInternType(list2);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getInternType();
  }, []);

  const displayDateRange = (
    <div className="d-flex align-items-start mt-2" style={{ width: "500px" }}>
      <div className="text-nowrap mx-2">เวลาเริ่มต้น</div>
      <DatePicker
        selected={startDate}
        onChange={(date) => {
          console.log({ date });
          setStartDate(date);
          setValue("startDate", date);
        }}
        customInput={<input className="form-control" name="startDate" />}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        name="startDate"
      />
      <div className="text-nowrap mx-2">เวลาสิ้นสุด</div>
      <DatePicker
        selected={endDate}
        onChange={(date) => {
          setEndDate(date);
          setValue("endDate", date);
        }}
        customInput={<input className="form-control" name="endDate" />}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        name="endDate"
      />

      <div className="text-primary text-nowrap mx-3">
        {startDate && endDate ? `${dateDiff(startDate, endDate)} วัน` : ""}
      </div>
    </div>
  );

  const displayType = (
    <CardEl title="ประเภท">
      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          ประเภท <span className="text-danger">*</span>
        </label>
        <div className="col-sm-10">
          <Controller
            control={control}
            required
            name="intern-type"
            render={({ field: { onChange, value, ref } }) => {
              return (
                <Select
                  ref={ref}
                  options={optionsInternType}
                  name="intern-type"
                  value={internType}
                  onChange={(ev) => {
                    onChange(ev.value);
                    setInternType(ev);
                    console.log(ev);

                    const start_date = ev?.data?.start_date;
                    const stop_date = ev?.data?.stop_date;

                    const std = start_date ? new Date(start_date) : "";
                    const ed = stop_date ? new Date(stop_date) : "";

                    console.log({ ed });
                    setStartDate(std);
                    setEndDate(ed);
                    setValue("startDate", std);
                    setValue("endDate", ed);
                  }}
                />
              );
            }}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          ช่วงเวลาฝึกงาน
        </label>
        <div className="col-sm-10">
          <fieldset className="mb-3">
            <div className="row">
              <div className="col-12">
                <label className="form-check my-3">
                  <input
                    name="radio-3"
                    type="radio"
                    className="form-check-input"
                    defaultChecked
                    disabled={!internType ? true : false}
                    value={1}
                    {...register("period")}
                  />
                  <span className="form-check-label">
                    ช่วงเวลาปกติ
                    {!!internType && (
                      <span>
                        <span>
                          : {convertDateToString(internType?.data?.start_date)}
                        </span>
                        <span> - </span>
                        <span>
                          {convertDateToString(internType?.data?.stop_date)}
                        </span>
                      </span>
                    )}
                  </span>
                </label>
                <label className="form-check my-3">
                  <input
                    name="radio-3"
                    type="radio"
                    className="form-check-input"
                    disabled={!internType ? true : false}
                    value={2}
                    {...register("period")}
                  />
                  <span className="form-check-label">เลือกช่วงเวลาเอง</span>
                </label>
                {watchPeriod == 2 ? displayDateRange : ""}
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </CardEl>
  );

  return <div>{displayType}</div>;
};

export default TypeEl;
